/* tslint:disable */
/* eslint-disable */
export enum LoyaltyProvider {
  None = 'NONE',
  Card = 'CARD',
  Digitalhub = 'DIGITALHUB'
}
